module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/backstage-module/components/venue-select-bar/venue-select-bar.component.scss
// module id = ./src/app/modules/backstage-module/components/venue-select-bar/venue-select-bar.component.scss
// module chunks = 9